import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetMyChallengeInvitations } from "../../api-clients/challengeInvitationsClient";

function useGetMyChallengeInvitationsQuery({
  page,
  limit,
  sort,
}: {
  page?: number;
  limit?: number;
  sort?: string;
} = {}) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.CHALLENGE.CHALLENGE_INVITATIONS],
    queryFn: () =>
      handleGetMyChallengeInvitations({
        page,
        limit,
        sort,
      }),
  });

  return { challengeInvitations: query.data, query };
}

export default useGetMyChallengeInvitationsQuery;
